import script from "./AvatarUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./AvatarUpload.vue?vue&type=script&setup=true&lang=ts"

import "./AvatarUpload.vue?vue&type=style&index=0&id=cf777b80&scoped=true&lang=css"

import exportComponent from "/home/runner/work/uup/uup/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf777b80"]])

export default __exports__